import { axios } from '@/utils/request'
import ipConfig from '../../config/ip.config'

export const api = {
  getOrdersPageListJson: ipConfig.api_gateway + '/api/Customer/GetOrdersPageListJson', // 获取当前客户订单列表
  getOrdersById: ipConfig.api_gateway + '/api/Customer/GetOrdersById', // 获取订单详情
  submitOrder: ipConfig.api_gateway + '/api/Customer/SubmitOrder', // 提交订单
  getLogistics: ipConfig.api_gateway + '/api/Customer/GetLogistics', // 获取订单物流信息
  getCustomerPointsInfo: ipConfig.api_gateway + '/api/Customer/GetCustomerPointsInfo', // 获取客户积分信息
  getProductsPageListJson: ipConfig.api_gateway + '/api/Customer/GetProductsPageListJson', // 获取商品列表
  getProductsById: ipConfig.api_gateway + '/api/Customer/GetProductsById', // 获取商品详情
  getProvinces: ipConfig.api_gateway + '/api/Customer/GetProvince', // 省
  getCity: ipConfig.api_gateway + '/api/Customer/GetCity', // 市
  getDistrict: ipConfig.api_gateway + '/api/Customer/GetDistrict', // 区
  getDownTawn: ipConfig.api_gateway + '/api/Customer/GetTownShip', // 街道
  submitOrderEvaluation: ipConfig.api_gateway + '/api/Customer/SubmitOrderEvaluation', // 提交客户评价
}

// 获取当前客户订单列表
export function getOrdersPageListJson (data) {
  return axios({
    url: api.getOrdersPageListJson,
    method: 'post',
    data
  })
}

// 获取订单详情
export function getOrdersById (data) {
  return axios({
    url: api.getOrdersById,
    method: 'post',
    data
  })
}

// 提交订单
export function submitOrder (data) {
  return axios({
    url: api.submitOrder,
    method: 'post',
    data
  })
}
// 获取订单物流信息
export function getLogistics (params) {
  return axios({
    url: api.getLogistics,
    method: 'post',
    params
  })
}
// 获取商品列表
export function getProductsPageListJson (data) {
  return axios({
    url: api.getProductsPageListJson,
    method: 'post',
    data
  })
}

// 获取客户积分信息
export function getCustomerPointsInfo (data) {
  return axios({
    url: api.getCustomerPointsInfo,
    method: 'post',
    data,
    params: data
  })
}

// 获取商品详情
export function getProductsById (params) {
  return axios({
    url: api.getProductsById,
    method: 'post',
    params
  })
}

// 获取省下拉
export function getProvinces (params) {
  return axios({
    url: api.getProvinces,
    method: 'post',
    params
  })
}
// 获取市下拉
export function getCity (params) {
  return axios({
    url: api.getCity,
    method: 'post',
    params
  })
}
// 获取区下拉
export function getDistrict (params) {
  return axios({
    url: api.getDistrict,
    method: 'post',
    params
  })
}
// 获取街道下拉
export function getDownTawn (params) {
  return axios({
    url: api.getDownTawn,
    method: 'post',
    params
  })
}

// 获取街道下拉
export function submitOrderEvaluation (params) {
  return axios({
    url: api.submitOrderEvaluation,
    method: 'post',
    params
  })
}
